import React from 'react';
import classes from './style.module.css'
import { Button } from 'react-bootstrap';

const ExportData = props => {

    const exportButtonClickedHandler = () => {
        let raceDate = props.selectionDate
        let raceId = document.querySelector("#raceId");
        if (raceId) {
            let raceId = document.querySelector("#raceId").innerHTML;
            window.location.href = "https://rdbwebapi.makebettinggreat.com/v1/export/race/" + raceId + "/" + raceDate
        } else {
            window.location.href = "https://rdbwebapi.makebettinggreat.com/v1/export/all/" + raceDate
        }
    }
    return (
        <div className={classes.ExportData}>
            <Button size="sm" variant="dark" onClick={exportButtonClickedHandler}>{props.label}</Button>
        </div>
    );
}

export default ExportData;